import React, { Component } from 'react';
import { createPortal } from 'react-dom';

import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';

import CloseButton from './CloseModalButton';

const overlayShow = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const contentShow = keyframes`
  from {
    opacity: 0;
    transform: translateY(15%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const contentUp = keyframes`
  from {
    opacity: 0.5;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Overlay = styled.div`
  align-items: center;
  animation: ${overlayShow} 300ms cubic-bezier(0.16, 1, 0.3, 1);
  background: rgba(0, 0, 0, 0.3);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  padding: 12px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: var(--zindex-modal);

  @media (max-width: 600px) {
    align-items: flex-end;
    padding: 0;
  }

  &[data-visible='false'] {
    display: none;
  }
`;

const Wrapper = styled.div`
  animation: ${contentShow} 300ms cubic-bezier(0.16, 1, 0.3, 1);
  background: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  max-width: 100%;
  overflow: hidden;
  position: relative;

  @media (max-width: 600px) {
    animation: ${contentUp} 400ms cubic-bezier(0.16, 1, 0.3, 1);
    border-radius: 10px 10px 0 0;
    min-height: 20%;
    padding: 32px 16px;
    width: 100%;
  }
`;

/*
 * Modal components
 */
class Modal extends Component {
  // Using class-based components because hooks are breaking @sayido/ui
  displayName = 'Modal';
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    isVisible: PropTypes.bool,
    preventClose: PropTypes.bool,
    setIsVisible: PropTypes.func,
  };
  componentDidMount() {
    this.keydownListener = event => {
      if (event.key === 'Escape') {
        this.props.setVisible(false);
      }
    };

    if (!this.props.preventClose) {
      window.addEventListener('keydown', this.keydownListener);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.keydownListener);
  }

  render() {
    const { children, isVisible, preventClose, setVisible } = this.props;

    const close = () => {
      if (!preventClose) {
        setVisible(false);
      }
    };

    return createPortal(
      <Overlay
        data-visible={isVisible}
        onClick={e => {
          if (e.target !== e.currentTarget) return;
          close();
        }}
      >
        <Wrapper>
          {!preventClose && <CloseButton onClick={close}>&#x2715;</CloseButton>}
          {children}
        </Wrapper>
      </Overlay>,
      document.body
    );
  }
}

Modal.Header = styled.div`
  width: 100%;
`;

Modal.Content = styled.div`
  overflow: auto;
`;

Modal.Actions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;

export default Modal;
